import React from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  IconButton,
  Typography,
  Box,
  Tooltip,
  alpha,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';

const drawerWidth = 240;

function Sidebar({ categories, onAddCategory, onSelectCategory, selectedCategory, onDeleteCategory, onEditCategory }) {
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          backgroundColor: 'grey.50',
        },
      }}
    >
      <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Categories
        </Typography>
      </Box>
      <List>
        {categories.map((category) => (
          <ListItem
            key={category.id}
            secondaryAction={
              <Box sx={{ opacity: 0, transition: 'opacity 0.2s', '.MuiListItem-root:hover &': { opacity: 1 } }}>
                <Tooltip title="Edit category">
                  <IconButton
                    edge="end"
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      onEditCategory(category);
                    }}
                    sx={{ mr: 1 }}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Delete category">
                  <IconButton
                    edge="end"
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDeleteCategory(category.id);
                    }}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>
            }
            disablePadding
            sx={{
              '&:hover': {
                '& .MuiListItemButton-root': {
                  backgroundColor: alpha(category.color, 0.08),
                },
              },
            }}
          >
            <ListItemButton
              selected={selectedCategory === category.id}
              onClick={() => onSelectCategory(selectedCategory === category.id ? null : category.id)}
              sx={{
                position: 'relative',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  left: 0,
                  top: 4,
                  bottom: 4,
                  width: 4,
                  backgroundColor: category.color,
                  borderRadius: '0 2px 2px 0',
                  transition: 'all 0.2s ease',
                  transform: selectedCategory === category.id ? 'scaleY(1.2)' : 'scaleY(1)',
                },
                pl: 3,
                backgroundColor: selectedCategory === category.id 
                  ? alpha(category.color, 0.12)
                  : 'transparent',
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: alpha(category.color, 0.08),
                  '&::before': {
                    transform: 'scaleY(1.2)',
                  }
                },
                '&.Mui-selected': {
                  backgroundColor: alpha(category.color, 0.12),
                  '&:hover': {
                    backgroundColor: alpha(category.color, 0.16),
                  },
                },
              }}
            >
              <ListItemText 
                primary={category.name}
                primaryTypographyProps={{
                  style: {
                    fontWeight: selectedCategory === category.id ? 600 : 400,
                    color: selectedCategory === category.id ? category.color : 'inherit',
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
        <ListItem disablePadding>
          <ListItemButton 
            onClick={onAddCategory}
            sx={{
              mt: 1,
              '&:hover': {
                backgroundColor: alpha('#2196f3', 0.05),
              },
            }}
          >
            <AddIcon sx={{ mr: 1, color: 'primary.main' }} />
            <ListItemText 
              primary="Add Category" 
              primaryTypographyProps={{
                color: 'primary',
                fontWeight: 500,
              }}
            />
          </ListItemButton>
        </ListItem>
      </List>
    </Drawer>
  );
}

export default Sidebar;